import { Customer } from './customer';
import { Dealer } from './dealer';
import { ServiceAddon } from './serviceaddon';
import { Tyre } from './tyre';

export class TyreAgreement {
  _id: string;
  customer: Customer;
  tyre: Tyre;
  addons: Array<ServiceAddon>;
  tyre_price: number;
  mounting_price: number;
  final_amount:number;
  contract_date:string;
  pdf:string;
  status: boolean;
  dealer_id: string;
  sellerInitials: string;
  change_tyre_1: boolean;
  change_tyre_2: boolean;
  change_tyre_3: boolean;
  change_tyre_4: boolean;
  order_type: string;
  customerAccept: boolean;
  order_completed: boolean;
  viewPDF: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/tyreAgreement.ts